import React, { useState, useCallback, useEffect } from 'react'
import styled from 'styled-components'
import { BigNumber } from 'bignumber.js'
import { Text } from 'rebass'

// components
import Modal, { ModalProps } from '../../../components/bakery/Modal'
import Row, { RowBetween } from '../../../components/Row'
import ArtworkBtn from '../../../components/nftInfo/button/ArtworkBtn'

// utils
import { BIGNUMBER_FMT } from '../../../constants/bakery'

// hooks
import { useActiveWeb3React } from '../../../hooks'
import useUserBids from '../../../hooks/nft/useUserBids'
import useUserAsks from '../../../hooks/nft/useUserAsks'
import { SUPPORTTYPE } from '../../../constants/bakery/nft'

const VedioModal = styled(Row)`
  position: fixed;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 308px;
  `}
`
const VedioCard = styled(Row)`
  flex-direction: column;
  padding: 48px 8px 20px;
  font-family: Baloo Da;
  position: relative;
  height: auto;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 28px 8px 20px;
  `}
`
const VedioPlay = styled.video`
  width: 582px;
  height: 582px;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    width: 290px;
    height: 290px;
  `}
`
const PlayFoot = styled.div`
  padding: 0 30px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  overflow: hidden;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    padding: 0;
  `}
`
const Title = styled.div`
  margin: 14px 0 4px 0;
  font-size: 24px;
  line-height: 44px;
  height: 44px;
  color: ${({ theme }) => theme.bsText4};
  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 16px;
  `}
`
const PlayLevel = styled.div`
  margin: 14px 0 4px 0;
  font-size: 24px;
  line-height: 44px;
  color: ${({ theme }) => theme.bsText7};
  ${({ theme }) => theme.mediaWidth.upToMedium`
    font-size: 16px;
  `}
`
const Disappear = styled.img`
  position: absolute;
  top: 0px;
  right: -30px;
  cursor: pointer;
  ${({ theme }) => theme.mediaWidth.upToMedium`
    top: -25px;
    right: 10px;
  `}
`
const BtnRow = styled(Row)`
  width: 244px;
`
interface PlayModalProps extends ModalProps {
  video: {
    tokenId: string
    name: string
    description: string
    imageUrl: string
    price?: string,
    nftType: string
    attributes: {
      animation_url: string
    }
    fileUrl: string
    auctionPrice: string
    maxBidPrice: string
  }
  isMyBinanceNft: any
  bakeBalance: number
  allowanceBuy: any
  nftType?: any
}

const PlayModal: React.FC<PlayModalProps> = ({
  onDismiss,
  video = {
    tokenId: '',
    name: '',
    price: '',
    nftType: '',
    attributes: {
      animation_url: ''
    },
    fileUrl: '',
    auctionPrice: '',
    maxBidPrice: ''
  },
  isMyBinanceNft = false,
  bakeBalance = 0,
  allowanceBuy = BigNumber,
  nftType = ''
}) => {
  const { account } = useActiveWeb3React()

  useEffect(() => {
    let video: any = document.getElementById('videoplay')
    if (video) {
      video.autoplay = 'autoplay'
      video.disablePictureInPicture = true
      video.style.outline = 'none'
      video.play()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const dismiss = useCallback(async () => {
    let video: any = document.getElementById('videoplay')
    video.pause()
    if (onDismiss) {
      onDismiss()
    }
  }, [onDismiss])

  // 获取我的竞价
  const getBids = useUserBids(nftType)
  const emptyBids: any[] = []
  const [ids, setIds] = useState(emptyBids)
  const getIds = useCallback(async() => {
    const bids = await getBids()
    if (bids.length) {
      const bidsId = bids.map((d: any) => {
        return d[0]
      })
      setIds(bidsId)
    }
  }, [getBids])

  // 获取我的挂单
  const getAsks = useUserAsks(nftType)
  const emptyAsks: any[] = []
  const [aksIds, setAskIds] = useState(emptyAsks)
  const getAskIds = useCallback(async() => {
    const asks = await getAsks()
    if (asks.length) {
      const asksId = asks.map((d: any) => {
        return d[0]
      })
      setAskIds(asksId)
    }
  }, [getAsks])

  useEffect(() => {
    if (account) {
      getAskIds()
      getIds()
    }
  }, [getBids, getIds, getAskIds, getAsks, account, video])

  return (
    <VedioModal>
      <Modal maxWidth={598} padding="0px">
        <Disappear onClick={dismiss} src="images/bianceNft/disappear.svg" alt=""></Disappear>
        <VedioCard>
          <VedioPlay id="videoplay" controls src={video.fileUrl}
            controlsList="nofullscreen nodownload noremoteplayback" poster={'images/bianceNft/' + video.name + '.jpg'}>
          </VedioPlay>
          <PlayFoot>
            <RowBetween style={{alignItems: 'center'}}>
              <Title>
                {video.name}
                <span style={{marginLeft: '10px'}}>{'#' + video.tokenId}</span>
              </Title>
              <PlayLevel>
                {video.price ? (new BigNumber(!video.auctionPrice ? video.price : video.maxBidPrice).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT)) : '-'}
                <Text fontSize={14} marginLeft="5px" style={{display: 'inline'}} fontFamily="Yuanti SC" fontWeight={700}>BAKE</Text>
              </PlayLevel>
            </RowBetween>
            <BtnRow>
              <ArtworkBtn
                artwork={video}
                status={1}
                isMyArtwork={isMyBinanceNft}
                ids={ids}
                myAksIds={aksIds}
                marketType={nftType}
                symbol={SUPPORTTYPE.BAKE}
              />
            </BtnRow>
          </PlayFoot>
        </VedioCard>
      </Modal>
    </VedioModal>
  )
}
export default PlayModal